import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";
import React from "react";
import "./JSONObjectComparer.scss";
import { T } from "services/lang/LanguageService";

type JSONObjectComparerProps = {
  oldValue: string;
  newValue: string;
  leftTitle?: string;
  rightTitle?: string;
};

const JSONObjectComparer = ({
  oldValue,
  newValue,
  rightTitle = T("label.new-code"),
  leftTitle = T("label.old-code"),
}: JSONObjectComparerProps) => (
  <ReactDiffViewer
    oldValue={oldValue}
    newValue={newValue}
    splitView
    compareMethod={"diffChars" as DiffMethod}
    leftTitle={<div className="middle-title">{leftTitle}</div>}
    rightTitle={<div className="middle-title">{rightTitle}</div>}
  />
);

export default JSONObjectComparer;
